export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13669.d03d4dfa.jpg";